import {
  CombinedGraphQLErrors,
  CombinedProtocolErrors,
  LinkError,
  ServerError,
  ServerParseError,
} from '@apollo/client/errors';
import type { GraphQLFormattedError } from 'graphql';
import isRecord from './isRecord';

/**
 * The GraphQL errors of a failed operation: the errors of CombinedGraphQLErrors, an empty list for the other errors
 * of an Apollo Client 4 operation (an ApolloError of Apollo Client 2 had `graphQLErrors: []` for them), null for
 * any other value.
 */
export const graphqlErrorsOf = (error: unknown): ReadonlyArray<GraphQLFormattedError> | null => {
  if (CombinedGraphQLErrors.is(error)) return error.errors;
  if (
    CombinedProtocolErrors.is(error) ||
    ServerError.is(error) ||
    ServerParseError.is(error) ||
    LinkError.is(error)
  )
    return [];
  return null;
};

/** `error.message` of a caught value, which the untyped code read without checking the value. */
export const messageOf = (error: unknown): string | undefined => {
  if (isRecord(error) && typeof error.message === 'string') return error.message;
  if (error instanceof Error) return error.message;
  return undefined;
};

export default messageOf;
